import React, { useState, useEffect, useCallback } from "react";
import { Input, Space, Select } from "antd";
import { Roles } from "../../__generated__/gql-types/globalTypes";

const { Search } = Input;

interface Props {
  onSearch: (searchTerm?: string, role?: Roles) => void;
  loading?: boolean;
  placeholder?: string;
}

const InputSearchWithFilters: React.FC<Props> = ({ 
  onSearch, 
  loading = false,
  placeholder = "Buscar por nombre, email o ID" 
}) => {
  const [searchText, setSearchText] = useState("");
  const [roleFilter, setRoleFilter] = useState<Roles | undefined>(undefined);
  const [debounceTimer, setDebounceTimer] = useState<NodeJS.Timeout | null>(null);

  const debouncedSearch = useCallback((text: string, role?: Roles) => {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    const timer = setTimeout(() => {
      if (text.trim() || role) {
        onSearch(text.trim() || undefined, role);
      } else {
        onSearch();
      }
    }, 500);

    setDebounceTimer(timer);
  }, [debounceTimer, onSearch]);

  useEffect(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [debounceTimer]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchText(value);
    
    if (value === "") {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      onSearch(undefined, roleFilter);
    } else {
      debouncedSearch(value, roleFilter);
    }
  };

  const handleSearchSubmit = (value: string) => {
    setSearchText(value);
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    onSearch(value.trim() || undefined, roleFilter);
  };

  const handleRoleChange = (value: string) => {
    const role = value === "all" ? undefined : (value as Roles);
    setRoleFilter(role);
    
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    onSearch(searchText.trim() || undefined, role);
  };


  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Space style={{ width: '100%' }}>
        <Search 
          placeholder={placeholder}
          value={searchText}
          onChange={handleSearchChange}
          onSearch={handleSearchSubmit}
          style={{ width: 350 }}
          allowClear
          enterButton 
          loading={loading}
        />
        <Select
          placeholder="Filtrar por rol"
          style={{ 
            width: 150, 
            border: '1px solid #d9d9d9', 
            borderRadius: '2px' 
          }}
          onChange={handleRoleChange}
          value={roleFilter || "all"}
          options={[
            { value: 'all', label: 'Todos los roles' },
            { value: Roles.teacher, label: 'Profesor' },
            { value: Roles.student, label: 'Alumno' },
          ]}
        />
      </Space>
    </Space>
  );
};

export default InputSearchWithFilters;
